import React from "react";
import { useParams, Link } from "react-router-dom";
import { blogPosts } from "../../data/blogPosts";
import "./styles.css";

const renderSectionContent = (section) => {
  const { paragraphs = [], list, quote } = section;

  return (
    <>
      {paragraphs.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
      {list && list.type === "unordered" && (
        <ul>
          {list.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
      {list && list.type === "ordered" && (
        <ol>
          {list.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ol>
      )}
      {quote && <blockquote>{quote}</blockquote>}
    </>
  );
};

const BlogArticle = () => {
  const { slug } = useParams();
  const post = blogPosts.find((entry) => entry.slug === slug);

  if (!post) {
    return (
      <article className="blog-article">
        <header className="blog-article__header">
          <h1>Article not found</h1>
        </header>
        <p>
          We could not locate the blog post you were trying to read. Return to
          the <Link to="/">home page</Link> to browse the latest articles.
        </p>
      </article>
    );
  }

  const { title, subtitle, publishedOn, readTime, sections } = post;

  return (
    <article className="blog-article">
      <header className="blog-article__header">
        <h1>{title}</h1>
        {subtitle && <p className="blog-article__subtitle">{subtitle}</p>}
        {(publishedOn || readTime) && (
          <p className="blog-article__meta">
            {publishedOn && <span>{publishedOn}</span>}
            {publishedOn && readTime && <span aria-hidden> • </span>}
            {readTime && <span>{readTime}</span>}
          </p>
        )}
      </header>
      {sections.map((section) => (
        <section className="blog-article__section" key={section.heading}>
          <h2>{section.heading}</h2>
          {renderSectionContent(section)}
        </section>
      ))}
    </article>
  );
};

export default BlogArticle;
